import Axios from 'axios';
import persistentData from '@/plugins/persistentData';

const InterceptorAPI = {
  getHeaders() {
    const params = {
      'Content-Type': "application/json"
    };
    if (persistentData.getData('jwtToken', false)) {
      params.Authorization = `Bearer ${persistentData.getData('jwtToken', false)}`;
    }
    return params;
  },
  get(endpoint) {
    return new Promise((resolve, reject) => {
      Axios.get(endpoint, { headers: this.getHeaders() })
        .then(res => resolve(res))
        .catch(err => {
          const status = err.response && err.response.status;
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(`[API] GET ${endpoint} status=${status}`, err.response && err.response.data);
          }
          if (status == 406) {
            persistentData.setData('errorServer', err.response.data.Message, false)
            window.mainApp.$router.push({path: '/vecino/errorServer'})
          } else {
            window.mainApp.$store.dispatch('addNotification', err.response.data.Message)
          }
          reject(err)
        })
    })
  },
  put(endpoint, data) {
    return new Promise((resolve, reject) => {
      Axios.put(endpoint, data, { headers: this.getHeaders() })
        .then(res => resolve(res))
        .catch(err => {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(`[API] PUT ${endpoint} status=${err.response && err.response.status}`, err.response && err.response.data);
          }
          window.mainApp.$store.dispatch('addNotification', err.response.data.Message)
          reject(err)
        })
    })
  },
  post(endpoint, data) {
    return new Promise((resolve, reject) => {
      Axios.post(endpoint, data, { headers: this.getHeaders() })
        .then(res => resolve(res))
        .catch(err => {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(`[API] POST ${endpoint} status=${err.response && err.response.status}`, err.response && err.response.data);
          }
          window.mainApp.$store.dispatch('addNotification', err.response.data.Message)
          reject(err)
        })
    })
  },
  authenticate: {
    get(endpoint) {
      return new Promise((resolve, reject) => {
        Axios.get(endpoint)
          .then(res => resolve(res))
          .catch(err => {
            window.mainApp.$store.dispatch('addNotification', err.response.data.Message)
            reject(err)
          })
      })
    },
    post(endpoint, data) {
      return new Promise((resolve, reject) => {
        Axios.post(endpoint, data)
          .then(res => resolve(res))
          .catch(err => {
            window.mainApp.$store.dispatch('addNotification', err.response.data.Message)
            reject(err)
          })
      })
    }
  }
}

export default InterceptorAPI